import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth';

const config = {
  apiKey: "AIzaSyDP3-OYPZDW6B0wfuluKOu7zkaX5kp2xVI",
  authDomain: "usele-9b2f2.firebaseapp.com",
  databaseURL: "https://usele-9b2f2-default-rtdb.firebaseio.com",
  projectId: "usele-9b2f2",
  storageBucket: "usele-9b2f2.appspot.com",
  messagingSenderId: "71940722526",
  appId: "1:71940722526:web:a363334b0b98e9d43a09cf",
  measurementId: "G-6B7S0QL83Q"
};

firebase.initializeApp(config);

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;

  const userRef = firestore.doc(`users/${userAuth.uid}`);

  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    const createdAt = new Date()

    try {
      await userRef.set({
        displayName,
        email,
        createdAt,
        ...additionalData
      })
    } catch (error) {
      console.log('error creating user', error.message)
    }
  }

  return userRef;
};

export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default firebase;